let baseUrl = "";
let fenceUrl = "";
let businessUrl = "";
let bw = "";
let shareUrl = "";
let geUrl = "";
let miniUrl = "";
let routerMode = "history";
let DEBUG = false;
let cancleHTTP = [];
let CommercialUrl = "";
let sdkappid = "";
let SECRETKEY = "";

if (process.env.NODE_ENV == "development") {
    baseUrl = "https://lxzf.wf12123.com/api";
    miniUrl = "https://mini.jiuyuandashi.com.cn";
    sdkappid = 1600117629;
    SECRETKEY = "6c09276932d44c943ac53551329cc00ca5a873aa90edc50fadc88b34f42a8329";
    DEBUG = true;
} else if (process.env.NODE_ENV == "testing") {
    baseUrl = "https://lxzf.wf12123.com/api";
    miniUrl = "https://mini.jiuyuandashi.com.cn";
    sdkappid = 1600117629;
    SECRETKEY = "6c09276932d44c943ac53551329cc00ca5a873aa90edc50fadc88b34f42a8329";
    DEBUG = false;
} else if (process.env.NODE_ENV == "production") {
    baseUrl = "https://lxzf.wf12123.com/api";
    miniUrl = "https://api.mini.jiuyuandashi.com.cn";
    sdkappid = 1600117629;
    SECRETKEY = "6c09276932d44c943ac53551329cc00ca5a873aa90edc50fadc88b34f42a8329";
}

let configuration = {
    projectName: "林西县公安局远程执法系统",
    miniName: "林西县公安局远程执法系统",
    loginLogo: "/static/images/commons/zf_common.png",
    menuLogo: "/static/images/commons/zf_common.png",
    provinceData: "内蒙古自治区",
    cityData: "赤峰市",
    carRegion: "蒙",
    treeList: [
        {
            areaName: "赤峰市",
            id: 403,
            children: [],
        },
    ],
    compensatRemark: "经双方共同请求调解达成一致：xxx承担全部车损，具体凭鉴定，就此结案。",
    newAccidentMethod: true,
}

let handle_pool = false;//警情池
let handle_im = false;//im聊天

let ProductKey = "DLS2eyJoYW5kc2hha2VDb2RlIjoiMTAxODM2MjM5LTEwMTgzNjI0NyIsIm1haW5TZXJ2ZXJVUkwiOiJodHRwczovL21sdHMuZHluYW1zb2Z0LmNvbS8iLCJvcmdhbml6YXRpb25JRCI6IjEwMTgzNjIzOSIsInN0YW5kYnlTZXJ2ZXJVUkwiOiJodHRwczovL3NsdHMuZHluYW1zb2Z0LmNvbS8iLCJjaGVja0NvZGUiOjE4NzkyODY2NH0=";
const pages_version = "V1.1.0";
const roomType = "cfzf_"; //正式
/* 注解：
    单独音视频配置，不需要roomType，需要把代码中的roomType去掉（views/zhifa/video.vue）；
    公共音视频配置，需要roomType，需要把代码中的roomType加上（views/zhifa/video.vue）；
*/

export default {
    configuration,
    sdkappid,
    SECRETKEY,
    baseUrl,
    fenceUrl,
    shareUrl,
    businessUrl,
    routerMode,
    DEBUG,
    cancleHTTP,
    CommercialUrl,
    bw,
    geUrl,
    miniUrl,
    handle_pool,
	handle_im,
    ProductKey,
    pages_version,
    roomType,
}



// WEBPACK FOOTER //
// ./src/common/env.js